import { ApolloError, WatchQueryFetchPolicy } from '@apollo/client';
import { useMemo } from 'react';
import defaultBiddingSettings from '../../shared/defaultSettings/defaultBiddingSettings';
import { BiddingSetting, useGetBiddingSettingQuery } from '../api';

const useBiddingSetting = (
    fetchPolicy: WatchQueryFetchPolicy = 'cache-first'
): {
    biddingSetting: Omit<BiddingSetting, '_id' | 'settingId' | 'lastUpdate'>;
    loading: boolean;
    error?: ApolloError;
    refetch: () => void;
} => {
    const { data, loading, error, refetch } = useGetBiddingSettingQuery({ fetchPolicy });

    return useMemo(
        () => ({
            biddingSetting: data?.biddingSetting ?? defaultBiddingSettings,
            loading,
            error: error ?? undefined,
            refetch: () => {
                refetch();
            },
        }),
        [data?.biddingSetting, loading, error, refetch]
    );
};

export default useBiddingSetting;
